"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const react_1 = __importDefault(require("react"));
const menu_1 = __importStar(require("@kyruus/menu"));
const ArrowUp_1 = __importDefault(require("@kyruus/react-ikons/ArrowUp"));
const ArrowDown_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown"));
const Dropdown_styles_1 = require("./Dropdown.styles");
const Dropdown = (_a) => {
    var { id, children, items, onClickItem, menuItemElement = 'li' } = _a, restProps = __rest(_a, ["id", "children", "items", "onClickItem", "menuItemElement"]);
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelectMenuItem = (item) => (event) => {
        event.persist();
        onClickItem && onClickItem(event, item);
        handleClose();
    };
    const menuListId = `${id}-list`;
    const open = Boolean(anchorEl);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_styles_1.DropdownButton, Object.assign({ id: id, mode: "flat", onClick: handleClick, type: "button", "aria-controls": menuListId, "aria-haspopup": "true", "aria-expanded": open }, restProps),
            children,
            open ? react_1.default.createElement(ArrowDown_1.default, { size: "24px" }) : react_1.default.createElement(ArrowUp_1.default, { size: "24px" })),
        react_1.default.createElement(menu_1.default, { MenuListProps: {
                id: menuListId
            }, anchorEl: anchorEl, getContentAnchorEl: null, open: open, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
            } }, items.map((item) => (react_1.default.createElement(menu_1.MenuItem, { key: item.id, onClick: handleSelectMenuItem(item), component: menuItemElement, href: menuItemElement === 'a' ? item.href : undefined }, item.label))))));
};
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map